import script from "./DashboardOpportunitiesWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardOpportunitiesWidget.vue?vue&type=script&setup=true&lang=js"

import "./DashboardOpportunitiesWidget.vue?vue&type=style&index=0&id=c037d316&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c037d316"]])

export default __exports__